module.exports = __webpack_public_path__ + "img/tempo_1.d300eb09.png";